import React, { useEffect, useState } from 'react'

import LoadingScreen from '../../components/LoadingScreen/LoadingScreen'
import LoginScreen from '../../components/LoginScreen/LoginScreen'
import { keycloak } from '../../services/keycloak'
import type { User } from '../../types/user'
import { jwtToUser, parseJwt } from '../../utils/AuthorizationUtils'

import AuthContext from './AuthorizationContext'

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const initAuth = async () => {
      try {
        const authenticated = await keycloak.initKeycloak()
        setIsAuthenticated(authenticated)
      } catch (error) {
        console.error('Failed to initialize Keycloak:', error)
      } finally {
        setIsLoading(false)
      }
    }

    initAuth()
  }, [])

  const login = () => keycloak.login()
  const logout = () => keycloak.logout()

  const getUserInfo = (): User => {
    const parsedJwt = parseJwt(keycloak.getToken() || '')
    const user = jwtToUser(parsedJwt)

    return user
  }

  const value = {
    isAuthenticated,
    isLoading,
    login,
    logout,
    getUserInfo,
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!isAuthenticated) {
    return <LoginScreen />
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
